import React, { ReactElement } from "react";

function IconClock({
  fill = "currentColor",
  size = 20,
}: {
  fill?: string;
  size?: number;
}): ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#icon-clock-clip)">
        <path
          d="M19.4141 9.41404C19.0905 9.41404 18.8282 9.67639 18.8282 9.99998C18.8282 14.8678 14.8679 18.8281 10.0001 18.8281C5.13228 18.8281 1.17203 14.8678 1.17203 9.99998C1.17203 5.13216 5.13228 1.1719 10.0001 1.1719C11.4844 1.1719 12.9283 1.54046 14.2172 2.24272L13.4847 2.97525C13.3171 3.14283 13.267 3.39482 13.3577 3.6138C13.4484 3.83275 13.662 3.97552 13.899 3.97552H16.7026C17.0262 3.97552 17.2885 3.71318 17.2885 3.38959V0.585971C17.2885 0.34898 17.1458 0.135348 16.9268 0.0446458C16.7078 -0.0460959 16.4558 0.00406008 16.2883 0.171676L15.0767 1.38327C13.542 0.477143 11.797 7.57171e-05 10.0001 7.57171e-05C7.32899 7.57171e-05 4.81775 1.04026 2.92901 2.92897C1.04027 4.81774 0.00012207 7.32894 0.00012207 10C0.00012207 12.6711 1.04027 15.1823 2.92901 17.071C4.81779 18.9598 7.32899 20 10.0001 20C12.6711 20 15.1823 18.9598 17.0711 17.071C18.9599 15.1823 20 12.6711 20 10C20 9.67639 19.7377 9.41404 19.4141 9.41404Z"
          fill={fill}
        />
        <path
          d="M13.7656 9.41403H10.5859V6.23437C10.5859 5.91078 10.3236 5.64844 10 5.64844C9.6764 5.64844 9.41406 5.91078 9.41406 6.23437V9.99996C9.41406 10.3236 9.6764 10.5859 10 10.5859H13.7656C14.0892 10.5859 14.3515 10.3236 14.3515 9.99996C14.3515 9.67637 14.0892 9.41403 13.7656 9.41403Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="icon-clock-clip">
          <rect width={20} height={20} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default IconClock;
